

















































































//import {functions,firestore} from "@/scripts/firebase";
import { GroupData, NoticeProps, UserPublicProfile } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'

//import { User } from 'firebase';
//import { StringOrNumber } from 'vee-validate/dist/types/types';
import Notice from '@/components/Notice.vue';
import PanelSelectUser from '@/components/PanelSelectUser.vue';


@Component({
  components: {
    Notice,
    PanelSelectUser
  }
})


export default class AddGroup extends Mixins(Common) {
  notice = {} as NoticeProps
  defaultGroupData: GroupData = {
    hostUids: undefined,
    guestUids: undefined,
    name: '',
    description: '',
    memberUids: undefined,
    disabled: false,
    deleted: false,
    memberMeta: {}
  }
  tIsShow = false
  sIsShow = false
  theGroup = {...this.defaultGroupData}
  isLoading = false

  $refs!: {
    hosts: InstanceType<typeof ValidationProvider>;
    guests: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  get disabledAddGroup(){
    return this.theGroup.name === '' || ! this.theGroup.guestUids || this.theGroup.guestUids.length === 0  || ! this.theGroup.hostUids || this.theGroup.hostUids.length === 0
  }

  get hostUids(){
    if(Array.isArray(this.theGroup.hostUids)){
      this.$refs.hosts.validate()
    }
    return this.theGroup.hostUids
  }

  get guestUids(){
    if(Array.isArray(this.theGroup.guestUids)){
      this.$refs.guests.validate()
    }
    
    return this.theGroup.guestUids
  }

  onSelect(type: 'host' | 'guest', event: false | UserPublicProfile){
    if(event === false){
      if(type === 'host'){
        this.tIsShow = false
      }
      if(type === 'guest'){
        this.sIsShow = false
      }
      return
    }
    this.toggleGroupMember(event,type)
  }

  async addGroup(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: GroupData = {
          ...this.theGroup
        }

        const GroupDocRef = await this.$createDoc(this.$getGroupsColRef(),data)
        
        await this.$waitUntilUpdatedForDoc(GroupDocRef)

        this.notice = {
          message: this.$t('addGroup.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theGroup = {...this.defaultGroupData}

        this.$refs.validationObserver.reset()
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addGroup.error') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  toggleGroupMember(user: string | UserPublicProfile, type: 'guest' | 'host'){

    const theUid = (typeof user === 'string') ? user : user.uid || ''

    const key = type + 'Uids' as 'guestUids' | 'hostUids'
    if(! this.theGroup[key]){
      this.theGroup[key] = []
    }

    if(this.theGroup[key] && this.theGroup[key]?.includes(theUid)){
      delete this.theGroup.memberMeta[theUid]
      this.theGroup[key] = this.theGroup[key]?.filter((uid) => {
        return uid !== theUid
      })
    }else{
      this.theGroup[key]?.push(theUid)
    }

    this.theGroup.memberUids = this.theGroup.hostUids?.concat(this.theGroup.guestUids || [])

    if(typeof user === 'object'){
      this.theGroup.memberMeta[theUid] = {
        ref: this.$getUserPublicProfileDocRef(theUid),
        displayName: user.displayName || '',
        lastName: user.lastName || '',
        firestName: user.firstName || '',
        lastNameYomigana: user.lastNameYomigana || '',
        firestNameYomigana: user.firstNameYomigana || ''
      }
    }
  }

  created(){
    console.trace('created')
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
